const normalizeWhitespaceText = (value) => {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim();
};

export default normalizeWhitespaceText;
